<template>
  <fragment>
    <h2
      class="blue-grey--text mb-1"
      :class="hideName ? 'mb-4' : 'mb-1'"
    >
      {{ title }}
    </h2>
    <p
      v-if="!hideName"
      class="body-2"
    >
      Health Assessment - {{ name }}
    </p>
  </fragment>
</template>

<script>
import { name } from '@/use/screener'

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    hideName: {
      type: Boolean,
      default: false
    }
  },
  setup: () => ({ name })
}
</script>
